import ServicePage from "./page";
import { carInsuranceData } from "@/mocks/insurancePages";

export default function CarInsurance() {
  return <ServicePage data={carInsuranceData} />;
}